define((require) => {
    "use strict";

    const _                = require("underscore");
    const Class            = require("shared/util/Class");
    const Preconditions    = require("shared/util/Preconditions");
    const GroupsDescriptor = require("shared/data/groups/GroupsDescriptor");

    const Type = GroupsDescriptor.AssetReferenceType;

    /**
     * Map of supported reference types, class (constructor function) to type (string).
     *
     * @private @type {Map.<Function, String>}
     */
    const types = GroupsDescriptor.assetReferenceTypes;

    /**
     * All static utilities for working with group references.
     *
     * @class GroupReference
     */
    const GroupReference = Class.extend("GroupReference", {}, {

        /**
         * Whether the specified type is considered valid/supported as a group reference type.
         *
         * @param  {String} type The reference type.
         * @return {Boolean}     <tt>true</tt> if the specified type is considered valid/supported as a group reference type.
         *
         * @see GroupsDescriptor
         */
        validType(type) {
            return _.contains(Type, type);
        },

        /**
         * Whether the specified reference is considered valid/supported as a group reference.
         *
         * @param  {ImprovedModel} reference The reference model.
         * @return {Boolean}           <tt>true</tt> if the specified reference is considered valid/supported as a group reference.
         *
         * @see GroupsDescriptor
         */
        validReference(reference) {
            return reference && types.has(reference.constructor);
        },

        /**
         * Returns the reference type, as a string, from the specified reference.
         *
         * @param  {ImprovedModel} reference The reference model.
         * @return {String}           The type.
         */
        typeFromReference(reference) {
            Preconditions.checkState(GroupReference.validReference(reference), `Invalid reference: ${reference}`);

            return types.get(reference.constructor);
        },

        /**
         * Returns the simple JSON representation of the reference - describing the id and type.<p>
         *
         * Example given an experience model:
         * <pre>
         * {
         *     resourceId: "564c4a8be4b0f586d5e23361",
         *     resourceType: "Experience"
         * }
         * </pre>
         *
         * @param  {ImprovedModel} reference The model to reference.
         * @return {Object}        Object containing <tt>resourceId</tt> and <tt>resourceType</tt>.
         */
        toJSON(reference) {
            Preconditions.checkState(GroupReference.validReference(reference), `Invalid reference: ${reference}`);

            return {
                resourceId: reference.identifier(),
                resourceType: GroupReference.typeFromReference(reference)
            };
        }

    });

    return GroupReference;
});



// WEBPACK FOOTER //
// ./src/shared/ui/groups/GroupAssetReference.js